import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import Button from '@mui/material/Button'
import Table from '@mui/material/Table'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableBody from '@mui/material/TableBody'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import Box from '@mui/material/Box'
import EditIcon from '@mui/icons-material/Edit'

function Row(props) {
 const {rol} = props
 const {evento} = props

 return (
   <TableRow>
     <TableCell>
       {rol.nombre}
     </TableCell>
    <TableCell>
      <Button variant="contained" color="primary" onClick={() => {evento(rol.id)}}><EditIcon /></Button>
    </TableCell>
  </TableRow>
 );
}


class RolesTable extends Component {

  constructor(props) {
    super(props)

    this.state = {
    };

    this.eventoSeleccionar = null
  }

  componentDidMount() {
  }

  render() {
    const roles = this.props.roles
    const eventoSeleccionar = this.props.eventoSeleccionar

    const columns = [
      {field: "nombre", headerName: 'Nombre', width: 200},
      {field: "", headerName: '', width: 50}
    ]

    return (
      <Box sx={{ maxWidth: 1200, overflow: 'hidden', borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        mb: 3 }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{
                  '& th': {
                    backgroundColor: 'primary.main',
                    color: 'primary.contrastText',
                    fontWeight: 'fontWeightBold',
                    fontSize: '0.8rem',
                    py: 1.5,
                    px: 2
                  }
                }}>
                {columns.map((column) => {
                  return(
                    <TableCell style={{width: column.width}} key={column.field}>{column.headerName}</TableCell>
                  )
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {roles.map((rol, idx) => {
                return(
                  <Row key={idx} rol={rol} evento={eventoSeleccionar} />
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    )
  }
}

export default RolesTable;
